import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  buttonsWrapper: {
    '&&': {
      marginBottom: SPACES.s,

      display: 'flex',
      gap: SPACES.xs,
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
  },
  button: {
    '&&': {
      minWidth: 150,
      height: '100%',

      boxShadow: `2px 4px 8px ${theme.palette.custom.grey}`,
      borderRadius: 20,

      fontSize: FONTS.SIZES.s,
      fontWeight: FONTS.WEIGHTS.bold,
      color: theme.palette.custom.white,
    },
  },
}))
